import { blue05, blue10, blue20, blue20opacity15, blue30 } from '../../colors/blue';
import { gray05, gray10, gray20, gray20opacity40, gray35, gray40opacity10, gray40opacity15, gray40opacity20, gray60, gray75, gray80, gray85, gray95, } from '../../colors/gray';
import { green02, green03 } from '../../colors/green';
import { indigo10, indigo20, indigo30, indigo40, indigo50, indigo60, indigo70, } from '../../colors/indigo';
import { lemon40, lemon60 } from '../../colors/lemon';
import { magenta02 } from '../../colors/magenta';
import { ocean01 } from '../../colors/ocean';
import { ochre20, ochre40 } from '../../colors/ochre';
import { orange02 } from '../../colors/orange';
import { purple20, purple40 } from '../../colors/purple';
import { red01, red02 } from '../../colors/red';
import { teal40, teal60 } from '../../colors/teal';
import { wine10, wine30 } from '../../colors/wine';
import { yellow01, yellow02 } from '../../colors/yellow';
export var palette = {
    mode: 'dark',
    primary: {
        main: blue20,
        contrastText: gray95,
        hover: blue10,
        active: blue30,
    },
    secondary: {
        main: gray40opacity15,
        contrastText: blue20,
    },
    text: {
        primary: gray20,
        hint: gray60,
        secondary: gray35,
        disabled: gray20opacity40,
    },
    background: {
        default: gray85,
        paper: gray75,
    },
    critical: {
        main: red02,
        contrastText: red01,
    },
    error: {
        main: red01,
        secondary: orange02,
        contrastText: gray80,
    },
    warning: {
        main: yellow02,
        contrastText: gray80,
    },
    info: {
        main: blue05,
        contrastText: gray80,
    },
    success: {
        main: green02,
        contrastText: gray80,
    },
    symbol: {
        ok: green03,
        info: ocean01,
        warning: yellow02,
        error: orange02,
        critical: red02,
        unknown: magenta02,
        offline: gray20,
        off: gray05,
    },
    status: {
        ok: green02,
        info: ocean01,
        warning: yellow01,
        error: orange02,
        critical: red02,
        unknown: magenta02,
        off: gray05,
        offline: gray60,
    },
    sequential: {
        default: indigo20,
        sequential_1: indigo70,
        sequential_2: indigo60,
        sequential_3: indigo50,
        sequential_4: indigo40,
        sequential_5: indigo30,
        sequential_6: indigo20,
        sequential_7: indigo10,
    },
    category: {
        indigoLight: indigo10,
        wineDark: wine30,
        lemonLight: lemon40,
        purpleDark: purple40,
        ochreLight: ochre20,
        tealDark: teal60,
        tealLight: teal40,
        indigoDark: indigo30,
        wineLight: wine10,
        lemonDark: lemon60,
        purpleLight: purple20,
        ochreDark: ochre40,
    },
    divider: gray40opacity20,
    action: {
        active: gray20,
        hover: gray40opacity10,
        selected: blue20opacity15,
        disabled: 'inherit',
        disabledBackground: 'inherit',
        disabledOpacity: 0.4,
    },
    neutral: { contrastText: gray10 },
    blue: { contrastText: blue05 },
    green: { contrastText: green02 },
    yellow: { contrastText: yellow02 },
    orange: { contrastText: orange02 },
    red: { contrastText: red01 },
    focusRing: {
        main: blue05,
    },
};
